import React from "react";
import { FieldBreakdownItem } from "../../data/api/ocrQualityApi";

const FIELD_LABELS: Record<string, string> = {
  gl_codes:    "GL Codes",
  vendor_id:   "Vendor",
  bill_number: "Bill Number",
  total:       "Total Amount",
  bill_date:   "Bill Date",
  gst_type:    "GST Type",
};

interface OcrFieldBreakdownChartProps {
  data: FieldBreakdownItem[];
}

export const OcrFieldBreakdownChart: React.FC<OcrFieldBreakdownChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={containerStyle}>
        <div style={headingStyle}>Field Edit Frequency</div>
        <div style={{ color: "#6b7280", fontSize: 14, padding: "32px 0", textAlign: "center" }}>
          No field data available.
        </div>
      </div>
    );
  }

  const maxRate = Math.max(...data.map((d) => Number(d.edit_rate)), 1);

  return (
    <div style={containerStyle}>
      <div style={headingStyle}>Field Edit Frequency</div>
      <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 16 }}>
        How often reviewers edit each field (% of documents)
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {data.map((item) => (
          <div key={item.field}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
              <span style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>
                {FIELD_LABELS[item.field] ?? item.field}
              </span>
              <span style={{ fontSize: 13, color: "#6b7280" }}>
                {Number(item.edit_rate).toFixed(1)}% ({item.edit_count} docs)
              </span>
            </div>
            <div
              style={{
                width: "100%",
                height: 8,
                background: "#f3f4f6",
                borderRadius: 4,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${(Number(item.edit_rate) / maxRate) * 100}%`,
                  height: "100%",
                  background: barColor(item.edit_rate),
                  borderRadius: 4,
                  transition: "width 0.4s ease",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function barColor(rate: number | string): string {
  rate = Number(rate);
  if (rate <= 20) return "#10b981";
  if (rate <= 50) return "#f59e0b";
  return "#ef4444";
}

const containerStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  padding: "20px 24px",
};

const headingStyle: React.CSSProperties = {
  fontSize: 15,
  fontWeight: 600,
  color: "#111827",
  marginBottom: 4,
};
